var pug = require("!./../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"wrapper\"\u003E\u003Ch1\u003Eボタンのホールド\u003C\u002Fh1\u003E\u003Cdiv class=\"content-wrapper\"\u003E\u003Cdiv class=\"buttons\"\u003E\u003Cbutton class=\"button button--anim--style\"\u003Enext\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button--active\"\u003EMore!\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


/*****************
 ** WEBPACK FOOTER
 ** ./app/posts/idea02.pug
 ** module id = 184
 ** module chunks = 0
 **/